import { createFileRoute } from '@tanstack/react-router'
import PlatformScroll from '@/components/PlatformScroll/PlatformScroll'

export const Route = createFileRoute('/platform-scroll')({
  component: PlatformScroll,
})
